import script from "./Payment.vue?vue&type=script&setup=true&lang=js"
export * from "./Payment.vue?vue&type=script&setup=true&lang=js"

import "./Payment.vue?vue&type=style&index=0&id=38cca38e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38cca38e"]])

export default __exports__